(() => {
  // overflow-slider-4.2.3-custom/dist/index.esm.js
  function details(slider) {
    var _a;
    let instance;
    let hasOverflow = false;
    let slideCount = 0;
    let containerWidth = 0;
    let containerHeight = 0;
    let scrollableAreaWidth = 0;
    let amountOfPages = 0;
    let currentPage = 0;
    if (Math.floor(slider.getInclusiveScrollWidth()) > Math.floor(slider.getInclusiveClientWidth())) {
      hasOverflow = true;
    }
    slideCount = (_a = slider.slides.length) !== null && _a !== void 0 ? _a : 0;
    containerWidth = slider.container.offsetWidth;
    containerHeight = slider.container.offsetHeight;
    scrollableAreaWidth = slider.getInclusiveScrollWidth();
    amountOfPages = Math.ceil(scrollableAreaWidth / containerWidth);
    if (Math.floor(slider.getScrollLeft()) >= 0) {
      currentPage = Math.floor(slider.getScrollLeft() / containerWidth);
      const maxScroll = scrollableAreaWidth - containerWidth - 2 * slider.getLeftOffset();
      if (slider.getScrollLeft() >= maxScroll - 1) {
        currentPage = amountOfPages - 1;
      }
    }
    instance = {
      hasOverflow,
      slideCount,
      containerWidth,
      containerHeight,
      scrollableAreaWidth,
      amountOfPages,
      currentPage
    };
    return instance;
  }
  function generateId(prefix, i = 1) {
    const id = `${prefix}-${i}`;
    if (document.getElementById(id)) {
      return generateId(prefix, i + 1);
    }
    return id;
  }
  function objectsAreEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (!Object.prototype.hasOwnProperty.call(obj2, key) || obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  }
  function getOutermostChildrenEdgeMarginSum(el) {
    if (el.children.length === 0) {
      return 0;
    }
    const firstChild = el.children[0];
    const firstChildStyle = getComputedStyle(firstChild);
    const firstChildMarginLeft = parseFloat(firstChildStyle.marginLeft);
    const lastChild = el.children[el.children.length - 1];
    const lastChildStyle = getComputedStyle(lastChild);
    const lastChildMarginRight = parseFloat(lastChildStyle.marginRight);
    return firstChildMarginLeft + lastChildMarginRight;
  }
  function Slider(container, options, plugins) {
    let slider;
    let subs = {};
    const overrideTransitions = () => {
      slider.slides.forEach((slide) => {
        slide.style.transition = "none";
      });
    };
    const restoreTransitions = () => {
      slider.slides.forEach((slide) => {
        slide.style.removeProperty("transition");
      });
    };
    function init() {
      slider.container = container;
      let containerId = container.getAttribute("id");
      if (containerId === null) {
        containerId = generateId("overflow-slider");
        container.setAttribute("id", containerId);
      }
      setSlides();
      overrideTransitions();
      setDetails(true);
      setActiveSlideIdx();
      slider.on("contentsChanged", () => {
        setSlides();
        setDetails();
        setActiveSlideIdx();
      });
      slider.on("containerSizeChanged", () => setDetails());
      let requestId = 0;
      const setDetailsDebounce = () => {
        if (requestId) {
          window.cancelAnimationFrame(requestId);
        }
        requestId = window.requestAnimationFrame(() => {
          setDetails();
          setActiveSlideIdx();
        });
      };
      slider.on("scroll", setDetailsDebounce);
      addEventListeners();
      setDataAttributes();
      setCSSVariables();
      if (plugins) {
        for (const plugin of plugins) {
          plugin(slider);
        }
        setDetails();
        setActiveSlideIdx();
        setCSSVariables();
        slider.emit("pluginsLoaded");
      }
      slider.on("detailsChanged", () => {
        setDataAttributes();
        setCSSVariables();
      });
      slider.emit("created");
      restoreTransitions();
      slider.container.setAttribute("data-ready", "true");
    }
    function setDetails(isInit = false) {
      const oldDetails = slider.details;
      const newDetails = details(slider);
      slider.details = newDetails;
      if (!isInit && !objectsAreEqual(oldDetails, newDetails)) {
        slider.emit("detailsChanged");
      } else if (isInit) {
        slider.emit("detailsChanged");
      }
    }
    function setSlides() {
      slider.slides = Array.from(slider.container.querySelectorAll(slider.options.slidesSelector));
    }
    function addEventListeners() {
      const observer = new MutationObserver(() => slider.emit("contentsChanged"));
      observer.observe(slider.container, { childList: true });
      const resizeObserver = new ResizeObserver(() => slider.emit("containerSizeChanged"));
      resizeObserver.observe(slider.container);
      let scrollTimeout;
      let nativeScrollTimeout;
      let programmaticScrollTimeout;
      let scrollLeft = slider.container.scrollLeft;
      let nativeScrollLeft = slider.container.scrollLeft;
      let programmaticScrollLeft = slider.container.scrollLeft;
      let isScrolling = false;
      let isUserScrolling = false;
      let isProgrammaticScrolling = false;
      slider.container.addEventListener("scroll", () => {
        const newScrollLeft = slider.container.scrollLeft;
        if (Math.floor(scrollLeft) !== Math.floor(newScrollLeft)) {
          if (!isScrolling) {
            isScrolling = true;
            slider.emit("scrollStart");
          }
          scrollLeft = newScrollLeft;
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            isScrolling = false;
            slider.emit("scrollEnd");
          }, 50);
          slider.emit("scroll");
        }
        if (isUserScrolling) {
          nativeScrollHandler();
        }
      });
      const nativeScrollHandler = () => {
        const newScrollLeft = slider.container.scrollLeft;
        if (Math.floor(nativeScrollLeft) !== Math.floor(newScrollLeft) && !isProgrammaticScrolling) {
          if (!isUserScrolling) {
            slider.emit("nativeScrollStart");
            isUserScrolling = true;
          }
          slider.emit("nativeScroll");
          nativeScrollLeft = newScrollLeft;
          clearTimeout(nativeScrollTimeout);
          nativeScrollTimeout = setTimeout(() => {
            isUserScrolling = false;
            slider.emit("nativeScrollEnd");
            programmaticScrollLeft = nativeScrollLeft;
          }, 50);
        }
      };
      slider.container.addEventListener("touchmove", nativeScrollHandler);
      slider.container.addEventListener("mousewheel", nativeScrollHandler);
      slider.container.addEventListener("wheel", nativeScrollHandler);
      slider.on("programmaticScrollStart", () => {
        isProgrammaticScrolling = true;
      });
      slider.container.addEventListener("scroll", () => {
        const newScrollLeft = slider.container.scrollLeft;
        if (Math.floor(programmaticScrollLeft) !== Math.floor(newScrollLeft) && !isUserScrolling && isProgrammaticScrolling) {
          programmaticScrollLeft = newScrollLeft;
          clearTimeout(programmaticScrollTimeout);
          programmaticScrollTimeout = setTimeout(() => {
            isProgrammaticScrolling = false;
            slider.emit("programmaticScrollEnd");
            nativeScrollLeft = programmaticScrollLeft;
          }, 50);
          slider.emit("programmaticScroll");
        }
      });
      slider.on("programmaticScrollStart", () => {
        slider.container.style.scrollSnapType = "none";
      });
      slider.on("nativeScrollStart", () => {
        slider.container.style.scrollSnapType = "";
      });
      let wasInteractedWith = false;
      slider.container.addEventListener("mousedown", () => {
        wasInteractedWith = true;
      });
      slider.container.addEventListener("touchstart", () => {
        wasInteractedWith = true;
      }, { passive: true });
      slider.container.addEventListener("focusin", (e) => {
        if (wasInteractedWith) {
          wasInteractedWith = false;
          return;
        }
        wasInteractedWith = false;
        if (!slider.details.hasOverflow) {
          return;
        }
        const focusedElement = e.target;
        let slide = focusedElement;
        while (slide.parentElement !== slider.container) {
          if (slide.parentElement) {
            slide = slide.parentElement;
          } else {
            return;
          }
        }
        slider.emit("programmaticScrollStart");
        setTimeout(() => {
          scrollFocusedSlideIntoView(slide, focusedElement);
          slider.emit("focusScroll");
        }, 50);
      });
    }
    function setCSSVariables() {
      slider.options.cssVariableContainer.style.setProperty("--slider-container-height", `${slider.details.containerHeight}px`);
      slider.options.cssVariableContainer.style.setProperty("--slider-container-width", `${slider.details.containerWidth}px`);
      slider.options.cssVariableContainer.style.setProperty("--slider-scrollable-width", `${slider.details.scrollableAreaWidth}px`);
      slider.options.cssVariableContainer.style.setProperty("--slider-slides-count", `${slider.details.slideCount}`);
      slider.options.cssVariableContainer.style.setProperty("--slider-x-offset", `${getLeftOffset()}px`);
      if (typeof slider.options.targetWidth === "function") {
        slider.options.cssVariableContainer.style.setProperty("--slider-container-target-width", `${slider.options.targetWidth(slider)}px`);
      }
    }
    function setDataAttributes() {
      slider.container.setAttribute("data-has-overflow", slider.details.hasOverflow ? "true" : "false");
      if (slider.options.rtl) {
        slider.container.setAttribute("dir", "rtl");
      }
    }
    function ensureSlideIsInView(slide, scrollBehavior = null) {
      const behavior = scrollBehavior || slider.options.scrollBehavior;
      const slideRect = slide.getBoundingClientRect();
      const sliderRect = slider.container.getBoundingClientRect();
      const containerWidth = slider.container.offsetWidth;
      const scrollLeft = slider.container.scrollLeft;
      const slideStart = slideRect.left - sliderRect.left + scrollLeft;
      const slideEnd = slideStart + slideRect.width;
      let scrollTarget = null;
      if (Math.floor(slideStart) < Math.floor(scrollLeft)) {
        scrollTarget = slideStart;
      } else if (Math.floor(slideEnd) > Math.floor(scrollLeft) + Math.floor(containerWidth)) {
        scrollTarget = slideEnd - containerWidth;
      } else if (Math.floor(slideStart) === 0) {
        scrollTarget = 0;
      } else {
        scrollTarget = slideStart;
      }
      if (scrollTarget !== null) {
        setTimeout((scrollTarget2) => {
          slider.emit("programmaticScrollStart");
          slider.container.scrollTo({ left: scrollTarget2, behavior });
        }, 50, scrollTarget);
      }
    }
    function scrollFocusedSlideIntoView(slide, focusedElement) {
      const isRtl = slider.options.rtl;
      const containerRect = slider.container.getBoundingClientRect();
      const containerWidth = slider.container.offsetWidth;
      const slideRect = slide.getBoundingClientRect();
      const scrollLeft = slider.container.scrollLeft;
      const slideLeftOffset = slideRect.left - containerRect.left;
      const slideRightOffset = slideRect.right - containerRect.right;
      if (slideLeftOffset >= -1 && slideRightOffset <= 1) {
        slider.container.style.scrollSnapType = "";
        slider.emit("programmaticScrollEnd");
        return;
      }
      let scrollTarget;
      if (slideRect.width <= containerWidth) {
        if (isRtl) {
          scrollTarget = scrollLeft + slideRightOffset;
        } else {
          scrollTarget = scrollLeft + slideLeftOffset;
        }
      } else if (focusedElement !== slide) {
        const focusRect = focusedElement.getBoundingClientRect();
        const focusLeftOffset = focusRect.left - containerRect.left;
        const focusRightOffset = focusRect.right - containerRect.right;
        if (focusLeftOffset >= -1 && focusRightOffset <= 1) {
          slider.container.style.scrollSnapType = "";
          slider.emit("programmaticScrollEnd");
          return;
        }
        if (focusRect.width <= containerWidth) {
          if (isRtl) {
            scrollTarget = scrollLeft + focusRightOffset;
          } else {
            scrollTarget = scrollLeft + focusLeftOffset;
          }
        } else {
          if (isRtl) {
            scrollTarget = scrollLeft + focusRightOffset;
          } else {
            scrollTarget = scrollLeft + focusLeftOffset;
          }
        }
      } else {
        if (isRtl) {
          scrollTarget = scrollLeft + slideRightOffset;
        } else {
          scrollTarget = scrollLeft + slideLeftOffset;
        }
      }
      slider.emit("programmaticScrollStart");
      slider.container.scrollTo({ left: scrollTarget, behavior: "auto" });
    }
    function setActiveSlideIdx() {
      const sliderRect = slider.container.getBoundingClientRect();
      const scrollLeft = slider.getScrollLeft();
      const slides = slider.slides;
      let activeSlideIdx = 0;
      let scrolledPastLastSlide = false;
      if (slider.options.rtl) {
        const scrolledDistance = slider.getInclusiveScrollWidth() - scrollLeft - slider.getInclusiveClientWidth();
        const slidePositions = [];
        for (let i = slides.length - 1; i >= 0; i--) {
          const slideRect = slides[i].getBoundingClientRect();
          const slideEnd = Math.abs(slideRect.left) - Math.abs(sliderRect.left) + scrolledDistance;
          slidePositions.push({
            slide: slides[i],
            slideEnd
          });
        }
        let closestSlide = null;
        let closestDistance = null;
        for (let i = 0; i < slidePositions.length; i++) {
          const distance = Math.abs(slidePositions[i].slideEnd - scrolledDistance);
          if (closestDistance === null || distance < closestDistance) {
            closestDistance = distance;
            closestSlide = slidePositions[i].slide;
          }
        }
        if (closestSlide) {
          activeSlideIdx = slides.indexOf(closestSlide);
        } else {
          activeSlideIdx = slides.length - 1;
        }
      } else {
        for (let i = 0; i < slides.length; i++) {
          const slideRect = slides[i].getBoundingClientRect();
          const slideStart = slideRect.left - sliderRect.left + scrollLeft + getGapSize();
          if (Math.floor(slideStart) >= Math.floor(scrollLeft)) {
            activeSlideIdx = i;
            break;
          }
          if (i === slides.length - 1) {
            scrolledPastLastSlide = true;
          }
        }
      }
      if (scrolledPastLastSlide) {
        activeSlideIdx = slides.length - 1;
      }
      const oldActiveSlideIdx = slider.activeSlideIdx;
      slider.activeSlideIdx = activeSlideIdx;
      if (oldActiveSlideIdx !== activeSlideIdx) {
        slider.emit("activeSlideChanged");
      }
    }
    function moveToSlide(idx) {
      const slide = slider.slides[idx];
      if (slide) {
        ensureSlideIsInView(slide);
      }
    }
    function canMoveToSlide(idx) {
      if (idx < 0 || idx >= slider.slides.length) {
        return false;
      }
      if (idx === slider.activeSlideIdx) {
        return false;
      }
      const direction = slider.options.rtl ? idx < slider.activeSlideIdx ? "backwards" : "forwards" : idx < slider.activeSlideIdx ? "backwards" : "forwards";
      const sliderRect = slider.container.getBoundingClientRect();
      const scrollLeft = slider.getScrollLeft();
      const containerWidth = slider.details.containerWidth;
      const hasUpcomingContent = slider.slides.some((s, i) => {
        if (i === slider.activeSlideIdx) {
          return false;
        }
        const sRect = s.getBoundingClientRect();
        const sStart = sRect.left - sliderRect.left + scrollLeft;
        const sEnd = sStart + sRect.width;
        if (slider.options.rtl) {
          if (scrollLeft === 0 && slider.details.hasOverflow) {
            return true;
          }
          return direction === "forwards" && i > slider.activeSlideIdx && Math.floor(sStart) < Math.floor(scrollLeft) || direction === "backwards" && i < slider.activeSlideIdx && Math.floor(sEnd) > Math.floor(scrollLeft + containerWidth);
        } else {
          return direction === "forwards" && i > slider.activeSlideIdx && Math.floor(sEnd) > Math.floor(scrollLeft + containerWidth) || direction === "backwards" && i < slider.activeSlideIdx && Math.floor(sStart) < Math.floor(scrollLeft);
        }
      });
      return hasUpcomingContent;
    }
    function moveToSlideInDirection(direction) {
      const activeSlideIdx = slider.activeSlideIdx;
      if (direction === "prev") {
        if (activeSlideIdx > 0) {
          moveToSlide(activeSlideIdx - 1);
        }
      } else if (direction === "next") {
        if (activeSlideIdx < slider.slides.length - 1) {
          moveToSlide(activeSlideIdx + 1);
        }
      }
    }
    function getInclusiveScrollWidth() {
      return slider.container.scrollWidth + getOutermostChildrenEdgeMarginSum(slider.container);
    }
    function getInclusiveClientWidth() {
      return slider.container.clientWidth + getOutermostChildrenEdgeMarginSum(slider.container);
    }
    function getScrollLeft() {
      return slider.options.rtl ? Math.abs(slider.container.scrollLeft) : slider.container.scrollLeft;
    }
    function setScrollLeft(value) {
      slider.container.scrollLeft = slider.options.rtl ? -value : value;
    }
    function getGapSize() {
      let gapSize = 0;
      if (slider.slides.length > 1) {
        const firstSlideRect = slider.slides[0].getBoundingClientRect();
        const secondSlideRect = slider.slides[1].getBoundingClientRect();
        gapSize = slider.options.rtl ? Math.abs(Math.floor(secondSlideRect.right - firstSlideRect.left)) : Math.floor(secondSlideRect.left - firstSlideRect.right);
      }
      return gapSize;
    }
    function getLeftOffset() {
      let offset = 0;
      const fullWidthOffset = slider.container.getAttribute("data-full-width-offset");
      if (fullWidthOffset) {
        offset = parseInt(fullWidthOffset);
      }
      return Math.floor(offset);
    }
    function moveToDirection(direction = "prev") {
      const scrollStrategy = slider.options.scrollStrategy;
      const scrollLeft = slider.container.scrollLeft;
      const sliderRect = slider.container.getBoundingClientRect();
      const containerWidth = slider.container.offsetWidth;
      let targetScrollPosition = scrollLeft;
      const realDirection = slider.options.rtl ? direction === "prev" ? "next" : "prev" : direction;
      if (realDirection === "prev") {
        targetScrollPosition = Math.max(0, scrollLeft - slider.container.offsetWidth);
      } else if (realDirection === "next") {
        targetScrollPosition = Math.min(slider.getInclusiveScrollWidth(), scrollLeft + slider.container.offsetWidth);
      }
      if (scrollStrategy === "fullSlide") {
        let fullSlideTargetScrollPosition = null;
        if (realDirection === "prev") {
          fullSlideTargetScrollPosition = Math.max(0, targetScrollPosition - getGapSize());
        } else {
          fullSlideTargetScrollPosition = Math.min(slider.getInclusiveScrollWidth(), targetScrollPosition + getGapSize());
        }
        if (realDirection === "next") {
          let partialSlideFound = false;
          for (let slide of slider.slides) {
            const slideRect = slide.getBoundingClientRect();
            const slideStart = slideRect.left - sliderRect.left + scrollLeft;
            const slideEnd = slideStart + slideRect.width;
            if (Math.floor(slideStart) < Math.floor(targetScrollPosition) && Math.floor(slideEnd) > Math.floor(targetScrollPosition)) {
              fullSlideTargetScrollPosition = slideStart;
              partialSlideFound = true;
              break;
            }
          }
          if (!partialSlideFound) {
            fullSlideTargetScrollPosition = Math.min(targetScrollPosition, slider.getInclusiveScrollWidth() - slider.container.offsetWidth);
          }
          if (fullSlideTargetScrollPosition) {
            if (Math.floor(fullSlideTargetScrollPosition) > Math.floor(scrollLeft)) {
              const maxScrollPosition = Math.floor(slider.getInclusiveScrollWidth()) - Math.floor(containerWidth);
              targetScrollPosition = Math.min(fullSlideTargetScrollPosition, maxScrollPosition);
            } else {
              targetScrollPosition = Math.min(slider.getInclusiveScrollWidth(), scrollLeft + containerWidth);
            }
          }
        } else {
          let partialSlideFound = false;
          for (let slide of slider.slides) {
            const slideRect = slide.getBoundingClientRect();
            const slideStart = slideRect.left - sliderRect.left + scrollLeft;
            const slideEnd = slideStart + slideRect.width;
            if (Math.floor(slideStart) < Math.floor(scrollLeft) && Math.floor(slideEnd) > Math.floor(scrollLeft)) {
              fullSlideTargetScrollPosition = slideEnd - containerWidth;
              partialSlideFound = true;
              break;
            }
          }
          if (!partialSlideFound) {
            fullSlideTargetScrollPosition = Math.max(0, scrollLeft - containerWidth);
          }
          if (fullSlideTargetScrollPosition && Math.floor(fullSlideTargetScrollPosition) < Math.floor(scrollLeft)) {
            targetScrollPosition = fullSlideTargetScrollPosition;
          }
        }
      }
      const offsettedTargetScrollPosition = targetScrollPosition - getLeftOffset();
      if (Math.floor(offsettedTargetScrollPosition) >= 0) {
        targetScrollPosition = offsettedTargetScrollPosition;
      }
      slider.emit("programmaticScrollStart");
      slider.container.style.scrollBehavior = slider.options.scrollBehavior;
      slider.container.scrollLeft = targetScrollPosition;
      setTimeout(() => slider.container.style.scrollBehavior = "", 50);
    }
    function snapToClosestSlide(direction = "prev") {
      var _a, _b;
      const { slides, options: options2, container: container2 } = slider;
      const { rtl, emulateScrollSnapMaxThreshold = 10, scrollBehavior = "smooth" } = options2;
      const isForward = rtl ? direction === "prev" : direction === "next";
      const scrollPos = getScrollLeft();
      const containerRect = container2.getBoundingClientRect();
      const factor = rtl ? -1 : 1;
      let targetAreaOffset = 0;
      if (typeof options2.targetWidth === "function") {
        try {
          const targetWidth = options2.targetWidth(slider);
          const containerWidth = containerRect.width;
          if (Number.isFinite(targetWidth) && targetWidth > 0 && targetWidth < containerWidth) {
            targetAreaOffset = (containerWidth - targetWidth) / 2;
          }
        } catch (error) {
        }
      }
      const slideData = [...slides].map((slide) => {
        const { width } = slide.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const relativeStart = slideRect.left - containerRect.left + scrollPos;
        const alignmentPoint = relativeStart - targetAreaOffset;
        const triggerPoint = Math.min(alignmentPoint + width / 2, alignmentPoint + emulateScrollSnapMaxThreshold);
        return { start: relativeStart - targetAreaOffset, trigger: triggerPoint };
      });
      let targetStart = null;
      if (isForward) {
        const found = slideData.find((item) => scrollPos <= item.trigger);
        targetStart = (_a = found === null || found === void 0 ? void 0 : found.start) !== null && _a !== void 0 ? _a : null;
      } else {
        const found = [...slideData].reverse().find((item) => scrollPos >= item.trigger);
        targetStart = (_b = found === null || found === void 0 ? void 0 : found.start) !== null && _b !== void 0 ? _b : null;
      }
      if (targetStart == null)
        return;
      const finalLeft = Math.max(0, Math.floor(targetStart)) * factor;
      container2.scrollTo({ left: finalLeft, behavior: scrollBehavior });
    }
    function on(name, cb) {
      if (!subs[name]) {
        subs[name] = [];
      }
      subs[name].push(cb);
    }
    function emit(name) {
      var _a;
      if (subs && subs[name]) {
        subs[name].forEach((cb) => {
          cb(slider);
        });
      }
      const optionCallBack = (_a = slider === null || slider === void 0 ? void 0 : slider.options) === null || _a === void 0 ? void 0 : _a[name];
      if (typeof optionCallBack === "function") {
        optionCallBack(slider);
      }
    }
    slider = {
      emit,
      moveToDirection,
      canMoveToSlide,
      moveToSlide,
      moveToSlideInDirection,
      snapToClosestSlide,
      getInclusiveScrollWidth,
      getInclusiveClientWidth,
      getLeftOffset,
      getGapSize,
      getScrollLeft,
      setScrollLeft,
      setActiveSlideIdx,
      on,
      options
    };
    init();
    return slider;
  }
  function OverflowSlider(container, options, plugins) {
    try {
      if (!(container instanceof Element)) {
        throw new Error(`Container must be HTML element, found ${typeof container}`);
      }
      const defaults = {
        cssVariableContainer: container,
        scrollBehavior: "smooth",
        scrollStrategy: "fullSlide",
        slidesSelector: ":scope > *",
        emulateScrollSnap: false,
        emulateScrollSnapMaxThreshold: 64,
        rtl: false
      };
      const sliderOptions = Object.assign(Object.assign({}, defaults), options);
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        sliderOptions.scrollBehavior = "auto";
      }
      return Slider(container, sliderOptions, plugins);
    } catch (e) {
      console.error(e);
    }
  }

  // overflow-slider-4.2.3-custom/dist/plugins/drag-scrolling/index.esm.js
  var DEFAULT_DRAGGED_DISTANCE_THAT_PREVENTS_CLICK = 20;
  function DragScrollingPlugin(args) {
    var _a;
    const options = {
      draggedDistanceThatPreventsClick: (_a = args === null || args === void 0 ? void 0 : args.draggedDistanceThatPreventsClick) !== null && _a !== void 0 ? _a : DEFAULT_DRAGGED_DISTANCE_THAT_PREVENTS_CLICK
    };
    return (slider) => {
      let isMouseDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let isMovingForward = false;
      let programmaticScrollStarted = false;
      let mayNeedToSnap = false;
      slider.container.setAttribute("data-has-drag-scrolling", "true");
      const mouseDown = (e) => {
        programmaticScrollStarted = false;
        if (!slider.details.hasOverflow) {
          return;
        }
        if (!slider.container.contains(e.target)) {
          return;
        }
        isMouseDown = true;
        startX = e.pageX - slider.container.getBoundingClientRect().left;
        scrollLeft = slider.container.scrollLeft;
        slider.container.style.cursor = "grabbing";
        slider.container.style.scrollBehavior = "auto";
        e.preventDefault();
        e.stopPropagation();
      };
      const mouseMove = (e) => {
        if (!slider.details.hasOverflow) {
          programmaticScrollStarted = false;
          return;
        }
        if (!isMouseDown) {
          programmaticScrollStarted = false;
          return;
        }
        e.preventDefault();
        if (!programmaticScrollStarted) {
          programmaticScrollStarted = true;
          slider.emit("programmaticScrollStart");
        }
        const x = e.pageX - slider.container.getBoundingClientRect().left;
        const walk = x - startX;
        const newScrollLeft = scrollLeft - walk;
        mayNeedToSnap = true;
        if (Math.floor(slider.container.scrollLeft) !== Math.floor(newScrollLeft)) {
          isMovingForward = slider.container.scrollLeft < newScrollLeft;
        }
        slider.container.scrollLeft = newScrollLeft;
        const absWalk = Math.abs(walk);
        const slides = slider.container.querySelectorAll(slider.options.slidesSelector);
        const pointerEvents = absWalk > options.draggedDistanceThatPreventsClick ? "none" : "";
        slides.forEach((slide) => {
          slide.style.pointerEvents = pointerEvents;
        });
      };
      const mouseUp = () => {
        if (!slider.details.hasOverflow) {
          programmaticScrollStarted = false;
          return;
        }
        isMouseDown = false;
        slider.container.style.cursor = "";
        setTimeout(() => {
          programmaticScrollStarted = false;
          slider.container.style.scrollBehavior = "";
          const slides = slider.container.querySelectorAll(slider.options.slidesSelector);
          slides.forEach((slide) => {
            slide.style.pointerEvents = "";
          });
        }, 50);
      };
      window.addEventListener("mousedown", mouseDown);
      window.addEventListener("mousemove", mouseMove);
      window.addEventListener("mouseup", mouseUp);
      if (slider.options.emulateScrollSnap) {
        const snap = () => {
          if (!mayNeedToSnap || isMouseDown) {
            return;
          }
          mayNeedToSnap = false;
          slider.snapToClosestSlide(isMovingForward ? "next" : "prev");
        };
        slider.on("programmaticScrollEnd", snap);
        window.addEventListener("mouseup", snap);
      }
    };
  }

  // overflow-slider-4.2.3-custom/dist/plugins/arrows/index.esm.js
  var DEFAULT_TEXTS = {
    buttonPrevious: "Previous items",
    buttonNext: "Next items"
  };
  var DEFAULT_ICONS = {
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.6 3.4l-7.6 7.6 7.6 7.6 1.4-1.4-5-5h12.6v-2h-12.6l5-5z"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 3.4l-1.4 1.4 5 5h-12.6v2h12.6l-5 5 1.4 1.4 7.6-7.6z"/></svg>'
  };
  var DEFAULT_CLASS_NAMES = {
    navContainer: "overflow-slider__arrows",
    prevButton: "overflow-slider__arrows-button overflow-slider__arrows-button--prev",
    nextButton: "overflow-slider__arrows-button overflow-slider__arrows-button--next"
  };
  function ArrowsPlugin(args) {
    return (slider) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const options = {
        texts: Object.assign(Object.assign({}, DEFAULT_TEXTS), (args === null || args === void 0 ? void 0 : args.texts) || []),
        icons: Object.assign(Object.assign({}, DEFAULT_ICONS), (args === null || args === void 0 ? void 0 : args.icons) || []),
        classNames: Object.assign(Object.assign({}, DEFAULT_CLASS_NAMES), (args === null || args === void 0 ? void 0 : args.classNames) || []),
        container: (_a = args === null || args === void 0 ? void 0 : args.container) !== null && _a !== void 0 ? _a : null,
        containerPrev: (_b = args === null || args === void 0 ? void 0 : args.containerPrev) !== null && _b !== void 0 ? _b : null,
        containerNext: (_c = args === null || args === void 0 ? void 0 : args.containerNext) !== null && _c !== void 0 ? _c : null,
        movementType: (_d = args === null || args === void 0 ? void 0 : args.movementType) !== null && _d !== void 0 ? _d : "view"
      };
      const nav = document.createElement("div");
      nav.classList.add(options.classNames.navContainer);
      const prev = document.createElement("button");
      prev.setAttribute("class", options.classNames.prevButton);
      prev.setAttribute("type", "button");
      prev.setAttribute("aria-label", options.texts.buttonPrevious);
      prev.setAttribute("aria-controls", (_e = slider.container.getAttribute("id")) !== null && _e !== void 0 ? _e : "");
      prev.setAttribute("data-type", "prev");
      prev.innerHTML = slider.options.rtl ? options.icons.next : options.icons.prev;
      prev.addEventListener("click", () => {
        if (prev.getAttribute("data-has-content") === "true") {
          options.movementType === "slide" ? slider.moveToSlideInDirection("prev") : slider.moveToDirection("prev");
        }
      });
      const next = document.createElement("button");
      next.setAttribute("class", options.classNames.nextButton);
      next.setAttribute("type", "button");
      next.setAttribute("aria-label", options.texts.buttonNext);
      next.setAttribute("aria-controls", (_f = slider.container.getAttribute("id")) !== null && _f !== void 0 ? _f : "");
      next.setAttribute("data-type", "next");
      next.innerHTML = slider.options.rtl ? options.icons.prev : options.icons.next;
      next.addEventListener("click", () => {
        if (next.getAttribute("data-has-content") === "true") {
          options.movementType === "slide" ? slider.moveToSlideInDirection("next") : slider.moveToDirection("next");
        }
      });
      nav.appendChild(prev);
      nav.appendChild(next);
      const update = () => {
        const scrollLeft = slider.getScrollLeft();
        const scrollWidth = slider.getInclusiveScrollWidth();
        const clientWidth = slider.getInclusiveClientWidth();
        const buffer = 1;
        if (Math.floor(scrollLeft) === 0) {
          prev.setAttribute("data-has-content", "false");
        } else {
          prev.setAttribute("data-has-content", "true");
        }
        const maxWidthDifference = Math.abs(Math.floor(scrollLeft + clientWidth) - Math.floor(scrollWidth));
        if (maxWidthDifference <= buffer) {
          next.setAttribute("data-has-content", "false");
        } else {
          next.setAttribute("data-has-content", "true");
        }
      };
      if (options.containerNext && options.containerPrev) {
        options.containerPrev.appendChild(prev);
        options.containerNext.appendChild(next);
      } else {
        if (options.container) {
          options.container.appendChild(nav);
        } else {
          (_g = slider.container.parentNode) === null || _g === void 0 ? void 0 : _g.insertBefore(nav, slider.container.nextSibling);
        }
      }
      update();
      slider.on("scrollEnd", update);
      slider.on("contentsChanged", update);
      slider.on("containerSizeChanged", update);
    };
  }

  // overflow-slider-4.2.3-custom/dist/plugins/scroll-indicator/index.esm.js
  var DEFAULT_CLASS_NAMES2 = {
    scrollIndicator: "overflow-slider__scroll-indicator",
    scrollIndicatorBar: "overflow-slider__scroll-indicator-bar",
    scrollIndicatorButton: "overflow-slider__scroll-indicator-button"
  };
  function ScrollIndicatorPlugin(args) {
    return (slider) => {
      var _a, _b, _c;
      const options = {
        classNames: Object.assign(Object.assign({}, DEFAULT_CLASS_NAMES2), (args === null || args === void 0 ? void 0 : args.classNames) || []),
        container: (_a = args === null || args === void 0 ? void 0 : args.container) !== null && _a !== void 0 ? _a : null
      };
      const scrollbarContainer = document.createElement("div");
      scrollbarContainer.setAttribute("class", options.classNames.scrollIndicator);
      scrollbarContainer.setAttribute("tabindex", "0");
      scrollbarContainer.setAttribute("role", "scrollbar");
      scrollbarContainer.setAttribute("aria-controls", (_b = slider.container.getAttribute("id")) !== null && _b !== void 0 ? _b : "");
      scrollbarContainer.setAttribute("aria-orientation", "horizontal");
      scrollbarContainer.setAttribute("aria-valuemax", "100");
      scrollbarContainer.setAttribute("aria-valuemin", "0");
      scrollbarContainer.setAttribute("aria-valuenow", "0");
      const scrollbar = document.createElement("div");
      scrollbar.setAttribute("class", options.classNames.scrollIndicatorBar);
      const scrollbarButton = document.createElement("div");
      scrollbarButton.setAttribute("class", options.classNames.scrollIndicatorButton);
      scrollbarButton.setAttribute("data-is-grabbed", "false");
      scrollbar.appendChild(scrollbarButton);
      scrollbarContainer.appendChild(scrollbar);
      const setDataAttributes = () => {
        scrollbarContainer.setAttribute("data-has-overflow", slider.details.hasOverflow.toString());
      };
      setDataAttributes();
      const getScrollbarButtonLeftOffset = () => {
        const contentRatio = scrollbarButton.offsetWidth / slider.details.containerWidth;
        const scrollAmount = slider.getScrollLeft() * contentRatio;
        if (slider.options.rtl) {
          return scrollbar.offsetWidth - scrollbarButton.offsetWidth - scrollAmount;
        }
        return scrollAmount;
      };
      let requestId = 0;
      const update = () => {
        if (requestId) {
          window.cancelAnimationFrame(requestId);
        }
        requestId = window.requestAnimationFrame(() => {
          const scrollbarButtonWidth = slider.details.containerWidth / slider.container.scrollWidth * 100;
          const scrollLeftInPortion = getScrollbarButtonLeftOffset();
          scrollbarButton.style.width = `${scrollbarButtonWidth}%`;
          scrollbarButton.style.transform = `translateX(${scrollLeftInPortion}px)`;
          const scrollLeft2 = slider.getScrollLeft();
          const scrollWidth = slider.getInclusiveScrollWidth();
          const containerWidth = slider.container.offsetWidth;
          const scrollPercentage = scrollLeft2 / (scrollWidth - containerWidth) * 100;
          scrollbarContainer.setAttribute("aria-valuenow", Math.round(Number.isNaN(scrollPercentage) ? 0 : scrollPercentage).toString());
        });
      };
      if (options.container) {
        options.container.appendChild(scrollbarContainer);
      } else {
        (_c = slider.container.parentNode) === null || _c === void 0 ? void 0 : _c.insertBefore(scrollbarContainer, slider.container.nextSibling);
      }
      update();
      slider.on("scroll", update);
      slider.on("contentsChanged", update);
      slider.on("containerSizeChanged", update);
      slider.on("detailsChanged", setDataAttributes);
      scrollbarContainer.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") {
          slider.moveToDirection("prev");
        } else if (e.key === "ArrowRight") {
          slider.moveToDirection("next");
        }
      });
      let isInteractionDown = false;
      let startX = 0;
      let scrollLeft = slider.getScrollLeft();
      scrollbarContainer.addEventListener("click", (e) => {
        if (e.target == scrollbarButton) {
          return;
        }
        const scrollbarButtonWidth = scrollbarButton.offsetWidth;
        const scrollbarButtonLeft = getScrollbarButtonLeftOffset();
        const scrollbarButtonRight = scrollbarButtonLeft + scrollbarButtonWidth;
        const clickX = e.pageX - scrollbarContainer.getBoundingClientRect().left;
        if (Math.floor(clickX) < Math.floor(scrollbarButtonLeft)) {
          console.log("move left");
          slider.moveToDirection(slider.options.rtl ? "next" : "prev");
        } else if (Math.floor(clickX) > Math.floor(scrollbarButtonRight)) {
          console.log("move right");
          slider.moveToDirection(slider.options.rtl ? "prev" : "next");
        }
      });
      const onInteractionDown = (e) => {
        isInteractionDown = true;
        const pageX = e.pageX || e.touches[0].pageX;
        startX = pageX - scrollbarContainer.offsetLeft;
        scrollLeft = slider.getScrollLeft();
        scrollbarButton.style.cursor = "grabbing";
        scrollbarButton.setAttribute("data-is-grabbed", "true");
        e.preventDefault();
        e.stopPropagation();
      };
      const onInteractionMove = (e) => {
        if (!isInteractionDown) {
          return;
        }
        e.preventDefault();
        const pageX = e.pageX || e.touches[0].pageX;
        const x = pageX - scrollbarContainer.offsetLeft;
        const scrollingFactor = slider.details.scrollableAreaWidth / scrollbarContainer.offsetWidth;
        const walk = (x - startX) * scrollingFactor;
        const distance = slider.options.rtl ? scrollLeft - walk : scrollLeft + walk;
        slider.setScrollLeft(distance);
      };
      const onInteractionUp = () => {
        isInteractionDown = false;
        scrollbarButton.style.cursor = "";
        scrollbarButton.setAttribute("data-is-grabbed", "false");
      };
      scrollbarButton.addEventListener("mousedown", onInteractionDown);
      scrollbarButton.addEventListener("touchstart", onInteractionDown);
      window.addEventListener("mousemove", onInteractionMove);
      window.addEventListener("touchmove", onInteractionMove, { passive: false });
      window.addEventListener("mouseup", onInteractionUp);
      window.addEventListener("touchend", onInteractionUp);
    };
  }

  // overflow-slider-4.2.3-custom/dist/plugins/dots/index.esm.js
  var DEFAULT_TEXTS2 = {
    dotDescription: "Page %d of %d"
  };
  var DEFAULT_CLASS_NAMES3 = {
    dotsContainer: "overflow-slider__dots",
    dotsItem: "overflow-slider__dot-item"
  };
  function DotsPlugin(args) {
    return (slider) => {
      var _a, _b, _c;
      const options = {
        type: (_a = args === null || args === void 0 ? void 0 : args.type) !== null && _a !== void 0 ? _a : "slide",
        texts: Object.assign(Object.assign({}, DEFAULT_TEXTS2), (args === null || args === void 0 ? void 0 : args.texts) || []),
        classNames: Object.assign(Object.assign({}, DEFAULT_CLASS_NAMES3), (args === null || args === void 0 ? void 0 : args.classNames) || []),
        container: (_b = args === null || args === void 0 ? void 0 : args.container) !== null && _b !== void 0 ? _b : null
      };
      const dots = document.createElement("div");
      dots.classList.add(options.classNames.dotsContainer);
      let pageFocused = null;
      let count = null;
      const buildDotListItem = (i) => {
        const dotListItem = document.createElement("li");
        const dot = document.createElement("button");
        dot.setAttribute("type", "button");
        dot.setAttribute("class", options.classNames.dotsItem);
        dot.setAttribute("aria-label", options.texts.dotDescription.replace("%d", (i + 1).toString()).replace("%d", count.toString()));
        dot.setAttribute("data-item", (i + 1).toString());
        dotListItem.appendChild(dot);
        dot.addEventListener("click", () => activateDot(i + 1));
        dot.addEventListener("focus", () => pageFocused = i + 1);
        dot.addEventListener("keydown", (e) => {
          var _a2;
          const currentItemItem = dots.querySelector(`[aria-pressed="true"]`);
          if (!currentItemItem) {
            return;
          }
          const currentItem = parseInt((_a2 = currentItemItem.getAttribute("data-item")) !== null && _a2 !== void 0 ? _a2 : "1");
          if (e.key === "ArrowLeft") {
            const previousIndex = currentItem - 1;
            if (previousIndex > 0) {
              const matchingDot = dots.querySelector(`[data-item="${previousIndex}"]`);
              if (matchingDot) {
                matchingDot.focus();
              }
              activateDot(previousIndex);
            }
          }
          if (e.key === "ArrowRight") {
            const nextIndex = currentItem + 1;
            if (nextIndex <= count) {
              const matchingDot = dots.querySelector(`[data-item="${nextIndex}"]`);
              if (matchingDot) {
                matchingDot.focus();
              }
              activateDot(nextIndex);
            }
          }
        });
        return dotListItem;
      };
      const buildDots = () => {
        dots.setAttribute("data-has-content", slider.details.hasOverflow.toString());
        count = options.type === "view" ? slider.details.amountOfPages : slider.details.slideCount;
        const currentIndex = options.type === "view" ? slider.details.currentPage : slider.activeSlideIdx;
        if (count <= 1) {
          dots.innerHTML = "";
          return;
        }
        let dotsList = dots.firstElementChild;
        if (!dotsList) {
          dotsList = document.createElement("ul");
          dots.appendChild(dotsList);
        }
        for (let i = 0; i < count; i++) {
          let dotListItem = dotsList.children[i];
          if (!dotListItem) {
            dotListItem = buildDotListItem(i);
            dotsList.appendChild(dotListItem);
          }
          const dot = dotListItem.firstElementChild;
          dot.setAttribute("aria-pressed", (i === currentIndex).toString());
        }
        for (let i = dotsList.children.length - 1; i >= count; i--) {
          dotsList.children[i].remove();
        }
        if (pageFocused) {
          const matchingDot = dots.querySelector(`[data-item="${pageFocused}"]`);
          if (matchingDot) {
            matchingDot.focus();
          }
        }
      };
      const activateDot = (index) => {
        if (options.type === "view") {
          const count2 = slider.details.amountOfPages;
          let targetPosition = slider.details.containerWidth * (index - 1);
          if (index === count2) {
            const maxScroll = slider.details.scrollableAreaWidth - slider.details.containerWidth;
            targetPosition = maxScroll;
          }
          const scrollLeft = slider.options.rtl ? -targetPosition : targetPosition;
          slider.container.scrollTo({
            left: scrollLeft,
            behavior: slider.options.scrollBehavior
          });
        } else {
          slider.moveToSlide(index - 1);
        }
      };
      buildDots();
      if (options.container) {
        options.container.appendChild(dots);
      } else {
        (_c = slider.container.parentNode) === null || _c === void 0 ? void 0 : _c.insertBefore(dots, slider.container.nextSibling);
      }
      slider.on("scrollEnd", buildDots);
      slider.on("contentsChanged", buildDots);
      slider.on("containerSizeChanged", buildDots);
      slider.on("detailsChanged", buildDots);
    };
  }

  // overflow-slider-4.2.3-custom/dist/plugins/skip-links/index.esm.js
  function generateId2(prefix, i = 1) {
    const id = `${prefix}-${i}`;
    if (document.getElementById(id)) {
      return generateId2(prefix, i + 1);
    }
    return id;
  }
  var DEFAULT_TEXTS3 = {
    skipList: "Skip list"
  };
  var DEFAULT_CLASS_NAMES4 = {
    skipLink: "screen-reader-text",
    skipLinkTarget: "overflow-slider__skip-link-target"
  };
  function SkipLinksPlugin(args) {
    return (slider) => {
      var _a, _b, _c, _d, _e, _f;
      const options = {
        texts: Object.assign(Object.assign({}, DEFAULT_TEXTS3), (args === null || args === void 0 ? void 0 : args.texts) || []),
        classNames: Object.assign(Object.assign({}, DEFAULT_CLASS_NAMES4), (args === null || args === void 0 ? void 0 : args.classNames) || []),
        containerBefore: (_a = args === null || args === void 0 ? void 0 : args.containerAfter) !== null && _a !== void 0 ? _a : null,
        containerAfter: (_b = args === null || args === void 0 ? void 0 : args.containerAfter) !== null && _b !== void 0 ? _b : null
      };
      const skipId = generateId2("overflow-slider-skip");
      const skipLinkEl = document.createElement("a");
      skipLinkEl.setAttribute("href", `#${skipId}`);
      skipLinkEl.textContent = options.texts.skipList;
      skipLinkEl.classList.add(options.classNames.skipLink);
      const skipTargetEl = document.createElement("div");
      skipTargetEl.setAttribute("id", skipId);
      skipTargetEl.setAttribute("tabindex", "-1");
      if (options.containerBefore) {
        (_c = options.containerBefore.parentNode) === null || _c === void 0 ? void 0 : _c.insertBefore(skipLinkEl, options.containerBefore);
      } else {
        (_d = slider.container.parentNode) === null || _d === void 0 ? void 0 : _d.insertBefore(skipLinkEl, slider.container);
      }
      if (options.containerAfter) {
        (_e = options.containerAfter.parentNode) === null || _e === void 0 ? void 0 : _e.insertBefore(skipTargetEl, options.containerAfter.nextSibling);
      } else {
        (_f = slider.container.parentNode) === null || _f === void 0 ? void 0 : _f.insertBefore(skipTargetEl, slider.container.nextSibling);
      }
    };
  }

  // overflow-slider.js
  window.tb_OverflowSlider = OverflowSlider;
  window.tb_OverflowSlider_plugins = {
    DragScrollingPlugin,
    ArrowsPlugin,
    ScrollIndicatorPlugin,
    DotsPlugin,
    SkipLinksPlugin
  };
})();
